import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/harapan-jaya.png'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "flex gap-4 h-screen" }
const _hoisted_3 = { class: "lg:w-1/2 md:w-full sm:w-full flex flex-col lg:justify-between left-form" }
const _hoisted_4 = { class: "mt-40px lg:mt-0" }

import {
  ref,
  onMounted,
  getCurrentInstance,
  reactive,
  computed
} from 'vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import { useRouter, useRoute } from 'vue-router'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import { iFormLogin } from '@/utils/interfaces/iLogin'
import moment from 'moment'
import environment from '@/configs/environtment'
import { generateCodeVerifier, generateCodeChallenge } from '@/composables/pages/auth/pkce'


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const loading = ref(false)
const router = useRouter()
const store = useStore()
const route = useRoute()
// const dataForm = ref()
// const loginChallenge = ref()
// const env = process.env
const version = localStorage.getItem('version')

const schema = Yup.object().shape({
  username: Yup.string().required('Username harus diisi'),
  password: Yup.string().required('Password harus diisi')
})

const initialValues: iFormLogin = {
  username: '',
  password: ''
}

const loginProcess = async (values: iFormLogin) => {
  console.log('xxx')
  await store.dispatch('loginProcess', {
    ...values
  }).then((res) => {
    const date = moment()
    localStorage.setItem('ut', res.result.access_token)
    localStorage.setItem('tt', res.result.token_type)
    localStorage.setItem('it', res.result.Id)
    localStorage.setItem('ei', date.toString())
    const ut = localStorage.getItem('ut')
    if (ut) {
      router.push({
        name: 'callback'
      })
    }
    // loading.value = false
    // let RedirectTo = res.result.RedirectTo
    // if (process.env.NODE_ENV === 'development') {
    //   RedirectTo = RedirectTo.replace('https://dev-api-akdp.harapan-jaya.com', window.location.origin)
    // }
    // window.location.href = res.result.RedirectTo
  }).catch((err) => {
    loading.value = false
    $toast.add({
      severity: 'error',
      detail: err.message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  })
}

const oauthProcess = async () => {
  const verifier = generateCodeVerifier()
  const challenge = await generateCodeChallenge(verifier)
  localStorage.setItem('pkce_verifier', verifier)

  console.log('challenge', challenge)
  const params = new URLSearchParams({
    response_type: `${environment.getSsoResponseType()}`,
    client_id: `${environment.getSsoClientId()}`,
    redirect_uri: `${environment.getSsoRedirectUri()}`,
    code_challenge: challenge,
    code_challenge_method: `${environment.getSsoCodeChallengeMethod()}`,
    scope: `${environment.getSsoScope()}`,
  })
  console.log('params', params.toString())

  window.location.href = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/auth?${params.toString()}`
}

const onSubmit = () => {
  loading.value = true
  oauthProcess()
  // window.location.href = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/auth?response_type=${environment.getSsoResponseType()}&client_id=${environment.getSsoClientId()}&redirect_uri=${environment.getSsoRedirectUri()}&code_challenge_method=${environment.getSsoCodeChallengeMethod()}&scope=${environment.getSsoScope()}&code_challenge=${environment.getSsoCodeChallenge()}`
  // loginProcess(values)
}

const toPage = (val: any) => {
  router.push({
    name: val
  })
}

const handleChange = () => {
  console.log('change')
}

const handleBlur = () => {
  console.log('blur')
}

const valueSwitch = computed({
  get: () => store.state.switchMenu,
  set: (val) => {
    store.dispatch('setSwitchMenu', val)
  }
})
// const valueSwitch = ref(0)
const listSwitchMenu = ref([
  { key: 0, label: 'HJP' },
  { key: 1, label: 'HJeX' },
])

const changePosition = (val: any) => {
  valueSwitch.value = val.key
  toPage('Home')
}

const toLoginHjex = () => {
  localStorage.setItem('auth', '1')
  toPage('Home')
}

onMounted(() => {
  localStorage.removeItem('auth')
  localStorage.removeItem('ut')
  localStorage.removeItem('it')
  localStorage.removeItem('ei')
  localStorage.removeItem('userInfo')
  localStorage.removeItem('rn')
  localStorage.removeItem('rt')
  localStorage.removeItem('tt')
  localStorage.removeItem('ud')
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "lg:hidden md:block sm:block px-10 py-16 top-info" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "h-10",
            alt: "logo"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "tet-36px font-extrabold" }, "Harapan Jaya Portal", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm font-normal text-grey-5" }, "Gunakan username dan password yang benar untuk mengakses website portal Harapan Jaya", -1)),
          _createVNode(_unref(Button), {
            class: "btn-primary mt-40px",
            id: "submit-login",
            loading: loading.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "mx-auto font-bold text-white" }, "Masuk", -1)
            ])),
            _: 1,
            __: [1]
          }, 8, ["loading"])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xs mt-60px lg:mt-0" }, [
          _createTextVNode("Copyright © "),
          _createElementVNode("span", { style: {"color":"#F44336","font-weight":"800"} }, "PT. Harapan Jaya Prima"),
          _createTextVNode(" Version: 1.0.0")
        ], -1))
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "image-right lg:w-1/2 lg:block md:hidden sm:hidden relative" }, [
        _createElementVNode("div", { class: "info absolute px-6 py-3" })
      ], -1))
    ])
  ]))
}
}

})